// Libraries
import React, {FunctionComponent} from 'react';
import {Typography} from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Constants
const {Title} = Typography;


export type TitleComponentType = {
  level: 1 | 2 | 3 | 4 | 5 | undefined;
  text: string;
  className?: string;
  onClick?: () => void;
};
const TitleComponent: FunctionComponent<TitleComponentType> = (
  {
    level, text, className, onClick,
  }) => {
  const { t } = useTranslation();

  return (
    <Title level={level} className={className} onClick={onClick}>
      {text}
    </Title>
  );
}

TitleComponent.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5]),
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default TitleComponent;